import ForgotPassword from "components/Login/ForgotPassword";
import React from "react";

const ForgotPasswordPage: React.FC = () => {
  return (
    <>
      <ForgotPassword />
    </>
  );
};

export default ForgotPasswordPage;
